import { DataBean } from "../../DataBean";


export class HealthIDType extends DataBean {

    public async getHealthIDTypeCatalog(idHealthIDType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getHealthIDTypeCatalog_Number", [idHealthIDType]);
    }

}